import { render } from "./newsLetters.vue?vue&type=template&id=7633960a&scoped=true"
import script from "./newsLetters.vue?vue&type=script&lang=js"
export * from "./newsLetters.vue?vue&type=script&lang=js"

import "./newsLetters.vue?vue&type=style&index=0&id=7633960a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7633960a"]])

export default __exports__